import clsx from 'clsx';
import CommonCard from '../CommonCard';
import { Row, Col } from 'react-bootstrap';
import LabeledText from '../LabeledText';
import classes from './PackageCard.module.css';
import { numberFormatter } from '../../../Helpers';
import { Accordion } from 'react-bootstrap';
import { packageDetails } from '../../../data';
import AccordionWrapper from '../../UI/AccordionWrapper';
import AccordionItem from '../../UI/AccordionItem';
const handleChildClick = (e) => {
  e.stopPropagation(); // Prevent the parent click handler from being triggered
};
const PackageCard = ({ headerCard, data, setter, markSelected, viewDetails, showLink = true }) => {


  return (
    <Col xl={3} lg={4} sm={6}>
      <CommonCard
        onClick={() => {
          setter();
        }}
        // Tag="button"
        className={clsx(classes.cardWrapper, {
          [classes.cardWithHeader]: headerCard,
          [classes.selectedCard]: markSelected
        })}>
        {headerCard && (
          <p
            className={clsx(classes.badge, {
              [classes.selectedBadge]: markSelected
            })}>
            Most Popular
          </p>
        )}
        <div className={classes.innerWrapper}>
          <LabeledText
            className={classes.cardTitle}
            label={data?.packageName}
            value={
              data?.baseAmount != data?.packageAmount
                ? `Rs. ${numberFormatter(data?.baseAmount)}`
                : ''
            }
          />
          <LabeledText
            className={classes.generalPackageInfo}
            label={`${numberFormatter(data?.noOfSMS)} SMS ${
              data?.packageDurationMonths === 1 ? 'per' : data?.packageDurationMonths
            } month`}
            value={`Rs. ${numberFormatter(data?.packageAmount)}`}
          />
          {showLink && <span className={classes.packageLink}>Select Package</span>}
        </div>
        {viewDetails && (
          <div onClick={handleChildClick} className={classes.moreInfoWrapper}>
            <AccordionWrapper>
              <AccordionItem
                className={classes.accordionCard}
                eventKey={`package-${data?.packageId}`}
                header={<h3 className={classes.detailHeading}>View Details</h3>}>
                <ul className={classes.packageListWrapper}>
                  {packageDetails?.map((data) => (
                    <li key={data} className={classes.infoList}>
                      <span></span> <p> {data}</p>
                    </li>
                  ))}
                </ul>
              </AccordionItem>
            </AccordionWrapper>
          </div>
        )}
      </CommonCard>
    </Col>
  );
};

export default PackageCard;
